import React from "react";
import { FormOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import _get from "lodash/get";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import { QfCollapse } from "../../../../theme";
import { assessmentResponseSelector } from "../../../selectors/assessmentDetail";
import "./IntroducerNotes.scss";

const { Panel } = Collapse;

const IntroducerNotes: React.FunctionComponent = () => {
  const assessment = useSelector(assessmentResponseSelector);
  const notesLink = `/application/applications/${assessment.externalId}/notes`;

  return (
    <div className="introducer-notes">
      <QfCollapse defaultActiveKey={["1"]} expandIconPosition="end" ghost>
        <Panel
          header={<div className="section-header-1">Introducer Notes</div>}
          key="1"
        >
          <div className="section-header-3">
            Introducer Notes{" "}
            <Link to={notesLink} className="edit-link">
              <FormOutlined />
            </Link>
          </div>
          <div
            className="note ql-editor"
            dangerouslySetInnerHTML={{
              __html: _get(assessment, "data.note.supportingNotes", ""),
            }}
          />
        </Panel>
      </QfCollapse>
    </div>
  );
};

export default IntroducerNotes;
